import React, { Component } from 'react';
import NavMenu from '../../components/navMenu/navMenu';
import HeaderMenu from '../../components/headerMenu/headerMenu';
import '../../assets/css/common.less';
import { requests, getToken, loadZhuKeToken, getLoginShopInfo, requestsByNotRes, getPlatformName, messageShow, matchSupplierProduct, toProductEditPage, systemConfig, getZkShopName, getTaoteShopName, fromClassName } from '../../utils/http';
import { batchDistributionRequest,commonRequest,LoadProductSkuMappingV2Request } from '../../utils/api';
import { Input, Select, Tabs, Button, Pagination, Steps, Tag, MessageBox, Message } from 'element-react';
import MyLoading from '../../components/showLoading/showLoading';
import ShowWarn from '../../components/showWarn/showWarn';
import PlatformName from '../../components/platformName/index.jsx';
import TableNavChange from '../../components/tableNavChange/tableNavChange';
import ShowModal from '../../components/showModal/index.jsx';
import $ from 'jquery';
import NewUserGuide from '../../components/newUserGuide/index.jsx';
import ChangeProductsModuleV2 from '../../components/changeProductsModuleV2/index.jsx';
import SkuMappingsModule from '../../components/skuMappingsModule/index.jsx';
import './index.less'
import { huoyuanLink, huoyuanLinkReport } from '../../utils/index.js';
import MyPopover from '../../components/popover/index.jsx';
import ChangeProductByAlibaba from '../../components/changeProductByAlibaba/index.jsx';
import { douyinInitilize,douyinComponentLoad } from '../../utils/douyinplugin.js';
import { productExposureReport } from '../../utils/alibabareport.js';

class proxyProduct extends Component {
    constructor(props) {
        super(props);
        this.state = {
            alibabaPageKey:'glhy',
            shopList: [],
            selectShopId: 0,
            isLoading: false,
            hasLoadBorder: false,//加载，背景框
            hasLoadShade: false,//加载 遮罩
            loadingTitle: '加载店铺信息...',
            selectPlatformType: '',
            distributionStatus: [
                { id: 0, value: "", title: "代销中", active: true, num: 0 },
                { id: 1, value: "", title: "已缺货", active: false, num: 0 },
                { id: 2, value: "", title: "终止代销", active: false, num: 0 }
            ],
            consignStatus: 0,// 0正常，1缺货，2终止代销

            consignProductList: [],//代销商品列表
            distributorProducts: [],
            relationCodeList: [],//选择的商品（列表）
            isNoShopList: false,//代销商品列表无数据时，显示无数据样式



            //分页 
            pageSize: 10,
            total: 0,
            current: 1,


            isShowRelevanceProduct: false,//显示关联商品页面
            isShowRelevanceProductOld: false,//显示旧的关联商品页面
            selectProduct: null,
            selectSupplierLoginId: '',
            selectSupplierProductId: '',
            supplierProductSkuList: '',
            selectPlatformTypeRelevance: '',
            selectSourcePlatform: '',


            isShowSyncInfo: false,//是否显示同步弹框
            syncParameterList: [],//同步需要的值


            isShowCancelProxy: false,//是否显示终止代销
            inputSetTimes: null,
            isShowWarnText: false,
            changeWidth: 650,

            isShowDeletedSku: false,//是否显示已删除的sku

            //灰度环境编码，灰度5环境的用户，显示新版一对多关联页面
            //2022-07-05，灰度5上正式，这里默认指向5. 等后续没问题了，old方法就隐藏
            environmentNumber: 0,

            isShowSetSyncProductStatus: false,
            shopListBySyncStats: [],//设置商品状态页面；店铺列表
            selectShopIdBySyncStats: 0,//设置商品状态页面；选择店铺Id
            selectPlatformTypeBySyncStats: '',//设置商品状态页面；选择的平台

            //根据商品id或商品标题查询
            searchType: 'ProductID',
            searchPlatform: '0',
            selectedShopProduct: null,
            isChangeProductsModule: false,
            activeSearchNavId: 0,
            //供应商商品来源标记
            productTag: null,

            skuMappingSelectProduct: null,
            skuMappingsModuleDailog: false,//规格映射弹窗
        };
    }
    componentDidMount() {
        var canshu = this.props.location.state;
        if (canshu != null && canshu != undefined) {
            var productTag = canshu.productTag;
            if (productTag)
                this.setState({ productTag: productTag });
        }
        douyinInitilize();
        var zhukeToken = getToken();
        var that = this;
        if (zhukeToken != "")
            that.loadData();
        else {

            setTimeout(() => {
                var zhukeTokenTwo = getToken();
                if (zhukeTokenTwo == "") {
                    var hasZhukeLoginShopTokens = localStorage.getItem("hasZhukeLoginShopTokens") || null;
                    //var hasZhukeLoginShopTokens = "";//测试。
                    if (hasZhukeLoginShopTokens != null && hasZhukeLoginShopTokens != "" && hasZhukeLoginShopTokens != undefined) {
                        loadZhuKeToken(hasZhukeLoginShopTokens);

                        setTimeout(() => {
                            var zhukeTokenThree = getToken();
                            if (zhukeTokenThree != "")
                                that.loadData();
                            else
                                that.setState({ isShowWarn: true });

                        }, 500);
                    } else
                        that.setState({ isShowWarn: true });
                } else
                    that.loadData();
            }, 500);

        }
    }

    changeLeftNav = (name) => {
        this.props.history.replace(name)
    }


    loadData() {
        var shopInfo = getLoginShopInfo();
        var that = this;
        this.setState({
            selectShopId: shopInfo.loginShopId,
            selectShopName: shopInfo.loginShopName,
            selectplatformType: shopInfo.loginShopPlatformType,
        }, () => {
            that.queryButton();
        })

    }




    //加载代销商品列表
    // loadList = () => {
    //     if (this.state.isShowWarn ==true) {
    //         Message({ message: '检测到未授权【铺货代发】应用，请授权！', offset: 60, type: "warning" });
    //         return;
    //     }



    //     var shopL = [];
    //     shopL.push(this.state.selectShopId);

    //     var status = "normal";
    //     if (this.state.consignStatus == 1)
    //         status = "stockout"
    //     else if (this.state.consignStatus == 2)
    //         status = "stopsell"

    //     var data = {
    //         ShopIdList: shopL,
    //         // ProductTitle: $("#productTitleId").val(),
    //         Status: status,
    //         PageIndex: this.state.current,
    //         PageSize: this.state.pageSize,
    //     }

    //     //if(systemConfig.isZk1() || systemConfig.isZk5())
    //     //{
    //         data.SourcePlatform = "all";
    //     //}
    //     if(this.state.searchPlatform == 1){
    //         data.SourcePlatform = "AlibabaZhuKe"
    //     }else if(this.state.searchPlatform == 2){
    //         data.SourcePlatform = "TaoteZhuKe"
    //     }
    //     var keyword = $("#productTitle").val();
    //     var searchType = this.state.searchType;
    //     if (searchType == "ProductID")
    //         data.PlatformProductId = keyword;
    //     else if (searchType == "ProductSubject")
    //         data.ProductTitle = keyword;

    //     var supplierLoginId = $("#supplierLoginId").val();
    //     if (supplierLoginId)
    //         data.SupplierLoginId = supplierLoginId;
    //     var that = this;
    //     //开启动画
    //     that.setState({
    //         isLoading: true,
    //         loadingTitle: '加载商品信息中...',
    //         consignProductList: [],
    //         relationCodeList: []
    //     });
    //     requests({
    //         url: "/BatchDistribution/GetConsignProductList",
    //         data: data,
    //         success: function (res) {
    //             //关闭动画
    //             that.setState({ isLoading: false });
    //             if (res.RequestError == true)//请求失效了。isLoading关闭看需求写
    //                 return;

    //             var distributionStatus = that.state.distributionStatus;
    //             if (res.Success) {
    //                 var listData = res.Data.ConsignProductList;
    //                 var totalCount = res.Data.TotalCount;

    //                 if (listData.length == 0) {
    //                     that.setState({
    //                         isNoShopList: true
    //                     })
    //                 } else {
    //                     that.setState({
    //                         isNoShopList: false
    //                     })
    //                 }

    //                 for (var i = 0; i < distributionStatus.length; i++) {
    //                     if (distributionStatus[i].active == true) {
    //                         distributionStatus[i].num = totalCount;
    //                         break;
    //                     }
    //                 }
    //                 that.setState({ consignProductList: listData, total: totalCount, distributionStatus: distributionStatus });

    //             } else {
    //                 messageShow("获取规格错误：" + res.Message, "error");
    //             }
    //         },
    //         fail: (err) => { }
    //     });

    // }

    loadList = async () => {
        if (this.state.isShowWarn == true) {
            Message({ message: '检测到未授权【铺货代发】应用，请授权！', offset: 60, type: "warning" });
            return;
        }

        var shopL = [];
        shopL.push(this.state.selectShopId);

        var status = "normal";
        if (this.state.consignStatus == 1)
            status = "stockout"
        else if (this.state.consignStatus == 2)
            status = "stopsell"

        const data = {
            ShopIdList: shopL,
            Status: status,
            PageIndex: this.state.current,
            PageSize: this.state.pageSize,
        }

        data.SourcePlatform = "all";
        if (this.state.searchPlatform == 1) {
            data.SourcePlatform = "AlibabaZhuKe"
        } else if (this.state.searchPlatform == 2) {
            data.SourcePlatform = "TaoteZhuKe"
        }
        var keyword = $("#productTitle").val();
        var searchType = this.state.searchType;
        if (searchType == "ProductID")
            data.PlatformProductId = keyword;
        else if (searchType == "ProductSubject")
            data.ProductTitle = keyword;

        var supplierLoginId = $("#supplierLoginId").val();
        if (supplierLoginId)
            data.SupplierLoginId = supplierLoginId;
        //开启动画
        this.setState({
            isLoading: true,
            loadingTitle: '加载商品信息中...',
            consignProductList: [],
            relationCodeList: []
        });
        const res = await batchDistributionRequest.GetConsignProductListV2(data);
        this.setState({ isLoading: false });
        if (res.RequestError == true)//请求失效了。isLoading关闭看需求写
            return;
        var distributionStatus = this.state.distributionStatus;
        if (res.Success) {
            var listData = res.Data.DistributorProducts || [];
            var totalCount = res.Data.TotalCount;
            const supplierProducts = res.Data.SupplierProducts;
            var pid=[];
            supplierProducts.forEach(x => {
                x.SourcePlatform = !x.SourcePlatform ? 'AlibabaZhuKe' : x.SourcePlatform;

                if(pid.includes(x.ProductId) == false){
                    pid.push(x.ProductId);
                }
            });
            this.state.isNoShopList = listData.length == 0 ? true : false

            const distributionStatu = distributionStatus.find(x => x.active == true)
            if (distributionStatu)
                distributionStatu.num = totalCount
            for (const item of listData) {
          
                for (const relation of item.Relations) {
                    relation.SourcePlatform = !relation.SourcePlatform ? 'AlibabaZhuKe' : relation.SourcePlatform
                    relation.SupplierProduct = supplierProducts.find(x => x.ProductId == relation.SupplierProductId && x.SourcePlatform == relation.SourcePlatform)
                }  
            }
            productExposureReport(pid,this.state.alibabaPageKey);
            this.setState({ distributorProducts: listData, total: totalCount, distributionStatus: distributionStatus });
        } else {
            messageShow("获取规格错误：" + res.Message, "error");
        }
    }
    loadDouyinProductPriceComponent(platformId)
    {
        douyinComponentLoad(this.state.selectShopId,this.state.selectShopName,"douyinProductPriceComponent",platformId);
    }


    queryButton = (isQuery) => {
        if (isQuery) {  //为true 时为搜索调用  current恢复第1页
            this.setState({ current: 1 }, () => {
                this.loadList();
            })
        } else {     //为切换页码时调用
            this.loadList();
        }

    }

    //切换状态
    changeNav = (item) => {

        this.setState({
            consignStatus: item.id,
            relationCodeList: [],
        });
        setTimeout(() => {
            this.loadList();
        }, 0);
    }

    changeCurrent = (current) => {
        this.setState({
            current,
            checkAll: false
        }, () => {
            this.queryButton();
        })
    }
    changePageSize = (size) => {
        this.setState({
            pageSize: size,
            current: 1,
        }, () => {
            this.queryButton();
        })
    }

    //显示关联弹框
    relevanceProducShowButt = (relationCode, platformType) => {
        this.closeRelevanceProduct();//显示前。先清除下数据

        //改成通过接口获取
        var productList = this.state.consignProductList;
        var productId = "";
        var shopId = 0;

        for (let i = 0; i < productList.length; i++) {
            var relation = productList[i].Relation;
            if (relation.RelationCode == relationCode) {
                productId = relation.ProductId;
                //supplierProductCode=relation.SupplierProductCode;
                shopId = relation.TargetShopId;
                //supplierProductId= relation.SupplierProductId
            }
        }


        var data = {
            ShopId: shopId,
            ProductId: productId
        };
        this.setState({ isLoading: true, loadingTitle: '获取信息中...' });
        var that = this;
        requests({
            url: "/Product/LoadProductSkuMapping",
            data: data,
            success: function (res) {
                //关闭动画
                that.setState({ isLoading: false });

                if (res.Success) {
                    var skuList = res.Data.AlibabaProductSku;
                    var product = res.Data.ProductFx;

                    var supplierProductSkuList = [];
                    if (skuList.length > 0) {
                        for (let i = 0; i < skuList.length; i++) {
                            supplierProductSkuList.push({
                                label: skuList[i].Color + skuList[i].Size,
                                value: skuList[i].SkuId
                            });
                        }
                    }
                    product.Skus.sort(s => s.SystemStatus);
                    var priceArr = [];
                    for (let i = 0; i < product.Skus.length; i++) {
                        priceArr.push(product.Skus[i].SalePrice);
                        //如果发现后台返回值的mappingcount为0，改为1
                        if (product.Skus[i].SupplierSkuList != null) {
                            for (let n = 0; n < product.Skus[i].SupplierSkuList.length; n++) {
                                if (product.Skus[i].SupplierSkuList[n].MappingCount == null || product.Skus[i].SupplierSkuList[n].MappingCount == 0) {
                                    product.Skus[i].SupplierSkuList[n].MappingCount = 1;
                                }
                            }
                        } else if (product.Skus[i].SupplierSkuId != null && product.Skus[i].SupplierSkuId > 0) {
                            product.Skus[i].SupplierSkuList = [];
                            product.Skus[i].SupplierSkuList.push({
                                SupplierSkuId: product.Skus[i].SupplierSkuId,
                                SupplierSkuName: product.Skus[i].SupplierSkuName,
                                MappingCount: 1
                            });
                        }
                    }
                    priceArr.sort();
                    product.PriceArr = priceArr;

                    that.setState({
                        selectProduct: product,
                        selectSupplierLoginId: res.Data.SupplierLoginId,
                        selectSupplierProductId: res.Data.SupplierProductId,
                        supplierProductSkuList: supplierProductSkuList,
                        selectPlatformTypeRelevance: platformType,
                        selectSourcePlatform: res.Data.SourcePlatform
                    }, () => {
                        $(".RelevanceProduct .SupplierSkuList-item-select").each((index, item) => { //有默认值时 高亮显示
                            if ($(item).val() != "") {
                                $(item).addClass("active")
                            }
                        })
                    });

                    that.setState({ isShowRelevanceProduct: true });
                } else {
                    messageShow("关联：" + res.Message, 'error');
                }
            },
        });
    }

    closeRelevanceProduct = () => {
        this.setState({
            isShowRelevanceProduct: false,//显示关联商品页面
            isShowRelevanceProductOld: false,
            selectProduct: null,
            selectSupplierLoginId: '',
            selectSupplierProductId: '',
            selectSourcePlatform: '',
            supplierProductSkuList: '',
            selectPlatformTypeRelevance: '',
        })
    }


    //确认更换货源
    changeProductConfirm = (relationCode, platformType) => {
        this.setState({
            confrimChangeProduct: true,
            relationCode: relationCode,
            platformType: platformType
        });
    }

    changeProductConfirm02 = (item, changeSearchNavsType,relation) => {

        console.log('relation =>',relation)
        this.setState({
            changeSupplierProduct:relation.SupplierProduct,
            confrimChangeProduct: true,
            // relationCode: item.Relation.RelationCode,
            platformType: item.Product.PlatformType,
            selectedShopProduct: item.Product,
            selectProductId: item.Product.PlatformId,
            changeSearchNavsType,
            changeProductType:0
        });
    }

    changeProductConfirmByAlibaba = (item,relation) => {

        console.log('relation =>',relation)
        this.setState({
            changeSupplierProduct:relation.SupplierProduct,
            confrimChangeProduct: true,
            platformType: item.Product.PlatformType,
            changeProductType:1,
            selectedShopProduct: item.Product,
            selectProductId: item.Product.PlatformId
        });
    }

    //1688低价找货源弹窗
    loadProductByAlibaba = (item, relation) => {
        console.log('changeProductConfirmByAlibaba->item =>', item)
        console.log('changeProductConfirmByAlibaba->relation =>', relation)
        this.setState({
            isChangeProductsModuleByAlibaba: true,
            confrimChangeProduct: false,
        });

    }

    addSupplierProduct(item,changeSearchNavsType){
        this.setState({
            changeSupplierProduct:null,
            isChangeProductsModule: true,
            platformType: item.Product.PlatformType,
            selectedShopProduct: item.Product,
            selectProductId: item.Product.PlatformId,
            changeSearchNavsType,
        });
    }
    //关闭确认更换货源弹窗
    closeConfrimChangeProduct = () => {
        this.setState({
            confrimChangeProduct: false,
            changeSupplierProduct:null,
        });
    }

    //关闭确认更换货源弹窗
    closeChangeProduct = () => {
        this.setState({
            isShowChangeProduct: false,
            changeWidth: 650
        });
    }

    //加载需要更换的货源
    loadProductSource = () => {
        this.setState({
            changeProduct: null,
            isShowChangeProduct: true,
            confrimChangeProduct: false,
            changeStatus: 'first',
            noticeText: "",
            isShowWarnText: false
        });
    }

    loadProductSource02 = () => {
        this.setState({
            isChangeProductsModule: true,
            confrimChangeProduct: false,
        });
    }

    inputTextareaByChangeProduct = () => {
        var setTimes = this.state.setTimes;
        if (setTimes != null) {
            clearTimeout(setTimes);
            this.setState({
                setTimes: setTimeout(() => { $("#textareaByChangeProductId").blur(); }, 1100)
            })
        }
        else {
            this.setState({
                setTimes: setTimeout(() => { $("#textareaByChangeProductId").blur(); }, 1100)
            })
        }
    }

    inputTextareaByChangeProduct = () => {
        var setTimes = this.state.setTimes;
        if (setTimes != null) {
            clearTimeout(setTimes);
            this.setState({
                setTimes: setTimeout(() => { $("#textareaByChangeProductId").blur(); }, 1100)
            })
        }
        else {
            this.setState({
                setTimes: setTimeout(() => { $("#textareaByChangeProductId").blur(); }, 1100)
            })
        }
    }

    //根据复制的url获取供应商产品信息
    async loadSupplierProduct(url) {
        var that = this;
        this.setState({
            changeProduct: null
        });

        if (url == null || url == '') {
            return;
        }

        // var regx = /detail.1688.com\/offer\/(.*?).html/g;
        // var rs = regx.exec(url);
        var data = {};

        // if (rs == undefined || rs == null || rs.length < 2 || rs[1] == '') {
        //     var numberRegx = /^[0-9]*$/g;
        //     rs = numberRegx.exec(url);
        //     if (rs == undefined || rs == null || rs.length < 1 || rs[1] == '') {
        //         that.setState({
        //             noticeText: '请输入正确格式的货源链接(例：https://detail.1688.com/offer/***.html或者商品ID)',
        //             isShowWarnText: true
        //         });
        //         return;
        //     } else {
        //         data.SupplierProductId = rs[0]
        //     }
        // } else {
        //     data.SupplierProductId = rs[1]
        // }
        const supplierProducts = matchSupplierProduct(url);
        if (supplierProducts.length == 0) {
            that.setState({
                noticeText: '请输入正确格式的货源链接(例：https://detail.1688.com/offer/***.html或淘口令)',
                isShowWarnText: true
            });
            return;
        }
        data.SupplierProductId = supplierProducts[0].supplierProductId
        data.SourcePlatform = supplierProducts[0].sourcePlatform

        that.setState({
            hasLoadBorder: true,
            noticeText: "正在抓取商品信息..",
            isShowLoadAction: true,
            isShowWarnText: false
        })

        if (supplierProducts[0].sourcePlatform == 'TaoteZhuKe' && !supplierProducts[0].supplierProductId) {
            const matchTaoteLinkRequestData = { Links: [supplierProducts[0].link] }
            const res = await batchDistributionRequest.MatchTaoteLink(matchTaoteLinkRequestData)
            if (res.Success) {
                if (res.Data.List && res.Data.List.length > 0) {
                    data.SupplierProductId = res.Data.List[0].Item2
                }
            }
            if (!data.SupplierProductId) {
                that.setState({
                    noticeText: '淘口令已失效',
                    isShowWarnText: true
                });
                return;
            }
        }
        requests({
            url: "/Product/LoadSupplierProduct",
            data: data,
            success: function (res) {
                that.setState({
                    isShowLoadAction: false
                });


                if (res.Success) {
                    var supplierProduct = res.Data.AlibabaProduct;

                    //遍历sku获取价格区间,供应商sku列表
                    var priceArr = [];
                    var supplierProductSkuList = [];
                    for (let i = 0; i < supplierProduct.Skus.length; i++) {
                        priceArr.push(supplierProduct.Skus[i].Price);
                        var attrArr = JSON.parse(supplierProduct.Skus[i].Attributes);
                        var color = '';
                        var size = '';

                        for (let n = 0; n < attrArr.length; n++) {
                            if (n == 0) {
                                color = attrArr[n].AttributeValue;
                            } else {
                                size = attrArr[n].AttributeValue;
                            }
                        }

                        supplierProductSkuList.push({
                            label: color + size,
                            value: supplierProduct.Skus[i].SkuId
                        });
                    }
                    priceArr.sort();

                    var changeProduct = {
                        ImageUrl: supplierProduct.Images[0],
                        Subject: supplierProduct.Subject,
                        PriceArr: priceArr,
                        SupplyStock: supplierProduct.SupplyStock,
                        Text: '',
                        Status: supplierProduct.Status,
                        SupplierLoginId: supplierProduct.SupplierLoginId
                    }

                    that.setState({
                        changeProduct: changeProduct,
                        supplierProductSkuList: supplierProductSkuList,
                        selectSupplierLoginId: supplierProduct.SupplierLoginId,
                        selectSupplierProductId: supplierProduct.ProductId,
                        selectSourcePlatform: supplierProduct.SourcePlatform
                    }, () => {
                        $(".changeProductsWrap .SupplierSkuList-item-select").each((index, item) => { //有默认值时 高亮显示
                            if ($(item).val() != "") {
                                $(item).addClass("active")
                            }
                        })
                    });
                } else {
                    that.setState({
                        noticeText: '非1688一件代发商品或当前商品需要通过厂家审核，请重新输入',
                        isShowWarnText: true
                    });
                }
            },
        });
    }

    //上一步
    previousChangeProduct = () => {
        this.setState({
            changeStatus: 'first',
            changeWidth: 650
        });
    }

    //显示关联弹框，从更换货源界面跳转
    relevanceProducFromChange = () => {
        var that = this;

        if (this.state.changeProduct == null) {
            messageShow("未获取到货源商品信息，请输入正确格式的货源链接!", 'warning');
            return;
        }

        this.setState({
            changeStatus: 'second',
            selectProduct: null,
            noticeText: '获取信息中...',
            changeWidth: 900,
        });

        //改成通过接口获取
        var productList = this.state.consignProductList;
        var productId = "";
        var shopId = 0;

        for (let i = 0; i < productList.length; i++) {
            var relation = productList[i].Relation;
            if (relation.RelationCode == this.state.relationCode) {
                productId = relation.ProductId;
                shopId = relation.TargetShopId;
            }
        }

        var data = {
            ShopId: shopId,
            ProductId: productId
        };

        requests({
            url: "/Product/LoadProductSkuMapping",
            data: data,
            success: function (res) {
                that.setState({ noticeText: '' });

                if (res.Success) {
                    var product = res.Data.ProductFx;

                    var priceArr = [];
                    for (let i = 0; i < product.Skus.length; i++) {
                        priceArr.push(product.Skus[i].SalePrice);
                        product.Skus[i].SupplierSkuList = null;
                    }
                    priceArr.sort();
                    product.PriceArr = priceArr;

                    that.setState({
                        selectProduct: product,
                        selectPlatformTypeRelevance: that.state.platformType
                    });
                } else {
                    messageShow("获取商品映射错误：" + res.Message, 'warning');
                }
            },
        });
    }


    //确认关联操作，保存
    sureRelevanceRequest = (isSomething) => {
        var selectProduct = this.state.selectProduct;
        var selectSupplierLoginId = this.state.selectSupplierLoginId;
        var selectSupplierProductId = this.state.selectSupplierProductId;
        var selectSourcePlatform = this.state.selectSourcePlatform;

        var skuMappingList = [];
        var skuList = selectProduct.Skus;

        for (let i = 0; i < skuList.length; i++) {
            if (skuList[i].SupplierSkuList == undefined || skuList[i].SupplierSkuList == null || skuList[i].SupplierSkuList[0].SupplierSkuId == "") {
                continue;
            }

            for (let n = 0; n < skuList[i].SupplierSkuList.length; n++) {
                if (skuList[i].SupplierSkuList[n].SupplierSkuId == undefined || skuList[i].SupplierSkuList[n].SupplierSkuId == null ||
                    skuList[i].SupplierSkuList[n].SupplierSkuId == "" || skuList[i].SupplierSkuList[n].MappingCount <= 0) {
                    continue;
                }

                skuMappingList.push({
                    SkuId: skuList[i].SkuId,
                    SupplierSkuId: skuList[i].SupplierSkuList[n].SupplierSkuId,
                    MappingCount: skuList[i].SupplierSkuList[n].MappingCount
                });
            }
        }

        //判断
        if (skuMappingList.length <= 0) {
            messageShow("供应商规不能全部为空！", "warning");
            return false;
        }

        // var selectShopPlatformType = $("#productListSelectShopId").find('option:selected').attr('platformType');

        var selectShopPlatformType = selectProduct.PlatformType;
        var dataJson = {
            SupplierProductId: selectSupplierProductId,
            SourcePlatform: selectSourcePlatform,
            SupplierMemberId: '',
            SupplierLoginId: selectSupplierLoginId,
            ProductId: selectProduct.PlatformId,
            TargetShopId: selectProduct.ShopId,
            SkuMappings: skuMappingList,
            TargetShopPt: selectShopPlatformType,
        }

        this.setState({
            isLoading: true,
            isShowRelevanceProduct: false,
            isShowRelevanceProductOld: false,
            isShowChangeProduct: false
        });
        var that = this;

        requests({
            url: "/BatchDistribution/RelateProduct",
            data: dataJson,
            success: (res) => {
                that.setState({ isLoading: false });
                if (res.Success) {
                    messageShow("重新映射成功。", 'success');

                    //如果更换产品不为空，则为更换货源入口，需要局部刷新代销商品界面的1688商品信息
                    if (that.state.changeProduct != null) {
                        var consignProductList = that.state.consignProductList;
                        for (let i = 0; i < consignProductList.length; i++) {
                            if (consignProductList[i].Relation.RelationCode == that.state.relationCode) {
                                consignProductList[i].SupplierProduct.PicURI = that.state.changeProduct.ImageUrl;
                                consignProductList[i].SupplierProduct.Status = that.state.changeProduct.Status;
                                consignProductList[i].SupplierProduct.Subject = that.state.changeProduct.Subject;
                                consignProductList[i].Relation.SupplierLoginId = that.state.changeProduct.SupplierLoginId;
                                break;
                            }
                        }
                        that.setState({ consignProductList: consignProductList, changeProduct: null });
                    }
                } else {
                    messageShow("重新映射失败：" + res.Message, 'error');
                }
            }
        });
    }

    sureChangeProductsModule = () => {
        this.setState({ isChangeProductsModule: false, confrimChangeProduct: false })
        this.queryButton(true);
    }


    //下拉  选中事件
    selectSupplierProduct = (e, skuId, index) => {

        var tarEle = e.target;
        if (tarEle.value != "") {
            $(tarEle).addClass("active")
        } else {
            $(tarEle).removeClass("active")
        }
        var supplierSkuId = e.target.parentNode.childNodes[0].selectedOptions[0].value;
        var supplierSkuName = e.target.parentNode.childNodes[0].selectedOptions[0].text;
        var mappingCount = e.target.parentNode.childNodes[1].value;

        if (mappingCount != null && mappingCount != '') {
            if (!(/(^[1-9]\d*$)/.test(mappingCount))) {
                e.target.parentNode.childNodes[1].value = 1;
                messageShow("数量必须填正整数的！", 'warning');
                return false;
            }
        }

        var selectProduct = this.state.selectProduct;
        var skuList = selectProduct.Skus;
        //商品
        for (let i = 0; i < skuList.length; i++) {
            if (skuId == skuList[i].SkuId) {
                if (skuList[i].SupplierSkuList == null || skuList[i].SupplierSkuList.length == 0) {
                    skuList[i].SupplierSkuList = [];
                    skuList[i].SupplierSkuList.push({
                        SupplierSkuId: supplierSkuId,
                        SupplierSkuName: supplierSkuName,
                        MappingCount: 1
                    });
                }
                else {
                    for (let n = 0; n < skuList[i].SupplierSkuList.length; n++) {
                        if (skuList[i].SupplierSkuList[n].SupplierSkuId == supplierSkuId && n != index) {
                            messageShow("该供应商规格在组合中已存在！", 'warning');
                            e.target.selectedIndex = 0;
                            skuList[i].SupplierSkuList.splice(index, 1);
                            return false;
                        }
                    }

                    skuList[i].SupplierSkuList[index].SupplierSkuId = supplierSkuId;
                    skuList[i].SupplierSkuList[index].SupplierSkuName = supplierSkuName;
                    skuList[i].SupplierSkuList[index].MappingCount = mappingCount;

                    if (supplierSkuId == undefined || supplierSkuId == null || supplierSkuId == '') {
                        messageShow("规格不能选择空，当前选择是无效的！", 'warning');
                        return false;
                    }
                }
            }
        }
        selectProduct.Skus = skuList;

        this.setState({ selectProduct: selectProduct })
    }

    //规格型号 添加规格
    addSupplierProductSku = (e, skuId) => {
        var selectProduct = this.state.selectProduct;
        var skuList = selectProduct.Skus;
        //商品
        for (let i = 0; i < skuList.length; i++) {
            if (skuId == skuList[i].SkuId) {
                if (skuList[i].SupplierSkuList == null) {
                    skuList[i].SupplierSkuList = [];
                    skuList[i].SupplierSkuList.push({
                        SupplierSkuId: '',
                        SupplierSkuName: '',
                        MappingCount: 1
                    });
                }

                skuList[i].SupplierSkuList.push({
                    SupplierSkuId: '',
                    SupplierSkuName: '',
                    MappingCount: 1
                });
            }
        }
        selectProduct.Skus = skuList;

        this.setState({ selectProduct: selectProduct })
    }

    //规格型号 删除规格
    deleteSupplierProductSku = (e, skuId, index) => {
        var selectProduct = this.state.selectProduct;
        var skuList = selectProduct.Skus;

        for (let i = 0; i < skuList.length; i++) {
            if (skuList[i].SkuId == skuId) {
                skuList[i].SupplierSkuList.splice(index, 1);
            }
        }

        selectProduct.Skus = skuList;
        this.setState({ selectProduct: selectProduct })
    }

    changeSelect = (name, value) => {
        this.setState({
            [name]: value
        })
    }
    closeChangeProductsModule = () => {
        this.setState({
            isChangeProductsModule: false,
            changeSupplierProduct:null,
        })
    }

    //确定关联货源  子传父
    sureChangeProductByAlibaba = (option) => {
        this.setState({isChangeProductsModuleByAlibaba:false, confrimChangeProduct: false});
        this.queryButton(true);
    }
    //关闭关联货源  子传父
    closeChangeProductByAlibaba=()=>{
    this.setState({
            isChangeProductsModuleByAlibaba: false,
            changeSupplierProduct:null
        })
    }
    
    //终止代销 操作
    cancelProxy(e, relationCode) {

        var that = this;
        var relationCodeList = [];
        if (relationCode != "")
            relationCodeList.push(relationCode);
        else
            relationCodeList = this.state.relationCodeList;

        if (relationCodeList.length == 0) {
            messageShow("请选择商品！", 'info');
            return;
        }

        this.setState({ isShowCancelProxy: true });
    }
    //全部，选择商品事件
    allCheckbox(types) {
        var isCheck = false;

        if (types == "above")
            isCheck = $("#allCheck_id_Above").prop("checked");//上面的按钮
        else
            isCheck = $("#allCheck_id_Below").prop("checked");//下面的按钮

        var productList = [];
        var consignProductList = this.state.distributorProducts;

        if (isCheck) {
            consignProductList.forEach(x => x.checked = true)
            productList = consignProductList.flatMap(s => s.Relations.map(x => x.RelationCode))
        } else {
            consignProductList.forEach(x => x.checked = false)
        }

        $("#allCheck_id_Below").prop("checked", isCheck);//上面的按钮点击，下面的全选跟着变化
        $("#allCheck_id_Above").prop("checked", isCheck);//下面的按钮点击，上面的全选跟着变化
        this.setState({ relationCodeList: productList });
    }
    //选择商品事件
    productCheckbox(item) {
        var list = [];
        item.checked = !item.checked;
        this.state.distributorProducts.forEach(x => {
            if (x.checked) list.push(...x.Relations.map(x => x.RelationCode));
        })
        this.setState({ relationCodeList: list });
    }
    //代销商品-- 同步按钮
    synchronization() {
        var list = this.state.distributorProducts;
        var relationCodeList = this.state.relationCodeList;

        if (relationCodeList.length == 0) {
            messageShow("请选择商品！", 'info');
            return;
        }
        console.log('relationCodeList =>',list)
        var parameterList = [];
        // for (var i = 0; i < list.length; i++) {
        //     var relation = list[i].Relation;
        //     var supplierProduct = list[i].SupplierProduct;
        //     for (var j = 0; j < relationCodeList.length; j++) {
        //         if (relation.RelationCode == relationCodeList[j]) {
        //             parameterList.push({
        //                 SupplierMemberId: supplierProduct.SupplierMemberId,
        //                 RelationCode: relation.RelationCode,
        //                 SupplierProductId: supplierProduct.ProductId,
        //                 SupplierProductCode: relation.SupplierProductCode,
        //                 ProductId: relation.ProductId,
        //                 ProductCode: relation.ProductCode,
        //                 SupplyStock: supplierProduct.SupplyStock,
        //                 TargetShopId: relation.TargetShopId,
        //             });
        //             break;
        //         }
        //     }
        // }
        for(const proxyProduct of list){
            var relations = proxyProduct.Relations;
            if(!relations || relations.length == 0)
                continue;

            for(const relation of relations){
                if(!relation.SupplierProduct) continue;
                const supplierProduct = relation.SupplierProduct;
                if(relationCodeList.includes(relation.RelationCode)){
                    parameterList.push({
                        SupplierMemberId: supplierProduct.SupplierMemberId,
                        RelationCode: relation.RelationCode,
                        SupplierProductId: supplierProduct.ProductId,
                        SourcePlatform: supplierProduct.SourcePlatform,
                        SupplierProductCode: relation.SupplierProductCode,
                        ProductId: relation.ProductId,
                        ProductCode: relation.ProductCode,
                        SupplyStock: supplierProduct.SupplyStock,
                        SourcePlatform: supplierProduct.SourcePlatform,
                        TargetShopId: relation.TargetShopId,
                    });
                }
            }
        }


        this.setState({
            isShowSyncInfo: true,
            syncParameterList: parameterList
        })
    }
    //终止代销  --关闭动作
    cancelProxyCloseButt() {
        this.setState({ isShowCancelProxy: false });
    }

    //终止代销弹框  --确认
    cancelProxyConfirmButt(param) {
        //是否选择【同时下架已铺货到店铺的商品】
        var isCheck = $("#cancelProxyCheckboxId").is(':checked');

        var data = param || {
            IsDeListing: isCheck,
            RelationCodes: this.state.relationCodeList //终止数组
        }
        var that = this;
        that.setState({ isLoading: true, loadingTitle: "终止代销中..", hasLoadBorder: true,isShowItemCancelProxy:false })

        //真实调用接口
        requests({
            url: "/BatchDistribution/UnConsign",
            data: data,
            success: function (res) {
                debugger
                //关闭动画
                that.setState({ isLoading: false, loadingTitle: "加载商品信息中...", isShowCancelProxy: false, hasLoadBorder: false,isShowItemCancelProxy:false })
                if (res.RequestError == true)//请求失效了。isLoading关闭看需求写
                    return;
                if (res.Success) {
                    var resList = res.Data.Relations;

                    var consignProductList = that.state.distributorProducts;
                    var errorList = [];
                    for (var i = 0; i < resList.length; i++) {
                        if (resList[i].IsSuccess == false) {
                            for (var j = 0; j < consignProductList.length; j++) {
                                const relation = consignProductList[j].Relations.find(x => x.RelationCode == resList[i].RelationCode)
                                if(relation){
                                    resList[i].ProductTitle = relation.SupplierProduct && relation.SupplierProduct.Subject;                                    ;
                                    break;
                                }
                            }
                            errorList.push(resList[i]);
                        }
                    }

                    if (errorList.length > 0) {
                        MessageBox.alert(
                            <div>
                                <div>一共有{errorList.length}个失败</div>
                                <div>
                                    <table>
                                        <tr>
                                            <td>1688商品名称：</td>
                                            <td>错误原因：</td>
                                        </tr>
                                        {
                                            errorList.map((item) =>
                                                <tr>
                                                    <td>{item.ProductTitle}</td>
                                                    <td>{item.Message}</td>
                                                </tr>
                                            )
                                        }
                                    </table>
                                </div>
                            </div>);
                    } else {
                        messageShow("终止成功。", 'success');
                        setTimeout(() => {
                            that.loadList();
                        }, 1300);
                    }
                } else
                    messageShow("终止代销错误：" + res.Message, 'error');
            },
        });
    }
    //同步弹框  --同步到后台/或者不同步到后台
    synchronizationSyncPlatform(isSyncToPlatform) {

        //var isCheck = $("#cancelProxyCheckboxId" ).is(':checked');

        var syncParameterList = this.state.syncParameterList;
        var data = {
            IsSyncToPlatform: isSyncToPlatform,
            RelationList: syncParameterList
        };
        var that = this;
        this.setState({ isLoading: true, loadingTitle: '同步信息中...', hasLoadBorder: true });
        requests({
            url: "/BatchDistribution/SyncProductInfoTask",
            data: data,
            success: function (res) {
                //关闭动画
                //that.setState({ isLoading: false, loadingTitle: "加载商品信息中...", hasLoadBorder: false });
                if (res.RequestError == true)//请求失效了。isLoading关闭看需求写
                {
                    that.setState({ isLoading: false });
                    return;
                }

                if (res.Success) {
                    // if (isSyncToPlatform)
                    //     app.MessageShow("success", res.Data, 3000);
                    // else
                    //     app.MessageShow("success", "已成功同步" + syncParameterList.length + "个商品。", 3000);
                    var taskCode = res.Data.TaskCode;
                    that.getSyncProductInfoTaskResult(taskCode, isSyncToPlatform, syncParameterList);
                    // setTimeout(() => {
                    //     that.loadList();
                    // }, 1300);
                } else {
                    that.setState({ isLoading: false });
                    messageShow("获取店铺列表错误：", 'error');
                }
            },
        });

        this.synchronizationCloseButt();
    }
    getSyncProductInfoTaskResult(taskCode, isSyncToPlatform, syncParameterList) {
        var that = this;

        commonRequest.GetZhuKeReqTask({ TaskCode: taskCode }).then((res) => {
            if (res.RequestError == true)//请求失效了。isLoading关闭看需求写
            {
                that.setState({ isLoading: false })
                return false;
            }
            if (res.Success) {
                var dates = res.Data;
                if (dates.FinishedTime) {
                    that.setState({ isLoading: false, loadingTitle: "加载商品信息中...", hasLoadBorder: false });
                    if (dates.Status == "Error" && dates.ErrorMsg) {
                        messageShow(dates.ErrorMsg, 'error');
                    } else {
                        var rspContentJson = JSON.parse(dates.RspContent);
                        if (isSyncToPlatform)
                            messageShow(rspContentJson.Msg, 'success');
                        else
                            messageShow("已成功同步" + syncParameterList.length + "个商品。", 'success');

                        setTimeout(() => { that.loadList(); }, 2000);
                    }
                } else {
                    setTimeout(() => { that.getSyncProductInfoTaskResult(taskCode, isSyncToPlatform, syncParameterList); }, 1000);
                }
            } else {
                that.setState({ isLoading: false });
            }
        });
    }
    //同步弹框  --关闭动作
    synchronizationCloseButt() {
        this.setState({
            isShowSyncInfo: false,
            syncParameterList: []
        })

    }

    showSkuMapping(product) {
        this.setState({
            skuMappingsModuleDailog: true,
            skuMappingSelectProduct: product,
        })
    }
    closeSkuMappingsModule = () => {
        this.setState({
            skuMappingsModuleDailog: false,
            skuMappingSelectProduct: null,
        })
    }

    delRelation = async (relation) =>{
        const mappings = relation.mappings;
        if(!mappings){
            this.setState({isLoading : true});
            const data = {ShopId : relation.TargetShopId,PlatformType : relation.TargetShopPt,ProductId:relation.ProductId}
            const res = await LoadProductSkuMappingV2Request(data);
            this.setState({isLoading : false});
            if(!res.Success){
                messageShow(res.Message,'error');
                return;
            }
            res.Relation = res.Data.Relation || []
            const apiRelation = res.Data.Relation.find(x => x.RelationCode == relation.RelationCode);
            relation.mappings = (apiRelation && apiRelation.SkuMappings) || []
        }
        this.setState({ isShowItemCancelProxy:true,isShowItemCancelProxyRelation:relation});
    }

    tableRender() {
        const ele =
            <table className="table-style01 orderList">
                <thead>
                    <tr>
                        <th style={{ width: "80px" }}>
                            <input type="checkbox" id="allCheck_id_Above" onClick={() => this.allCheckbox("above")} />
                        </th>
                        <th style={{ width: "25%", minWidth: "300px" }}>店铺商品信息</th>
                        <th style={{ minWidth: "100px" }}>已关联货源商品信息</th>
                        <th style={{ width: "180px",textAlign:'center' }} >操作</th>
                    </tr>
                </thead>
                <tbody>

                    {
                        this.state.isNoShopList ?
                            <tr>
                                <td className="noneData" colSpan="20">
                                    <div className="noneData-wrap">
                                        <i className="iconfont icon-wushuju"></i>
                                        <span className="noneData-title">暂无数据！</span>
                                    </div>
                                </td>
                            </tr> : null
                    }

                    {this.state.distributorProducts.map((item) =>
                        <tr key={item.Product.PlatformId} >
                            <td>
                                {
                                    item.checked ?
                                        <input type="checkbox" key={item.Product.PlatformId} checked onClick={() => this.productCheckbox(item)} /> :
                                        <input type="checkbox" key={item.Product.PlatformId} onClick={() => this.productCheckbox(item)} />
                                }

                            </td>
                            <td>
                                <div className="productShow table-product">
                                    <div className="productShow-imgWrap">
                                        <img src={item.Product.ImageUrl} alt="" />
                                    </div>
                                    <ul>
                                        <li title={item.Product.Subject}>
                                            <span style={{'whiteSpace':'nowrap','overflow':'hidden','textOverflow':'ellipsis','width':'400px','display':'inline-block'}}>{item.Product.Subject}</span>
                                        </li>
                                        <li>
                                            <span>商品Id：{item.Product.PlatformId}</span>
                                        </li>
                                        <li style={{display: 'flex', height: '16px'}}>
                                            <span>价格：￥{item.Product.minPrice}</span>&nbsp;&nbsp;
                                            {this.state.selectplatformType=="TouTiao"?
                                              <span style={{"color":"#ffa929","cursor": "pointer"}}  id={"douyinPrice"+item.Product.PlatformId}  onClick={()=>this.loadDouyinProductPriceComponent(item.Product.PlatformId)}>查看价格力</span>:null
                                             }
                                        </li>
                                    </ul>
                                </div>
                            </td>
                            <td style={{padding:'0 0px'}}>
                                <div className='relationWrap'>
                                    {
                                        item.Relations.map(relation =>
                                            <div className='relationWrap-item' key={relation.RelationCode}>
                                                <div class="productShow table-product">
                                                    <div class="productShow-imgWrap">
                                                        <img src={relation.SupplierProduct && relation.SupplierProduct.PicURI} alt="" />
                                                    </div>
                                                    <ul>
                                                        <li title={relation.SupplierProduct && relation.SupplierProduct.Subject}>
                                                            <span className={fromClassName({
                                                                hover:true,
                                                                defColor:relation.SourcePlatform == "TaoteZhuKe" ? false:true
                                                            })} onClick={()=>{ huoyuanLinkReport(relation.SupplierProduct,this.state.alibabaPageKey)}}>{relation.SupplierProduct && relation.SupplierProduct.Subject}</span>
                                                            
                                                            {/* {
                                                                relation.SourcePlatform == "TaoteZhuKe" ?
                                                                    <span className='tagStatus tagWarn' style={{ "borderRadius": "12px", marginLeft: "10px" }}>淘特货源 </span> : null
                                                            }
                                                            {
                                                                (!relation.SourcePlatform || relation.SourcePlatform == 'AlibabaZhuKe') ?
                                                                    <span className='tagStatus tagWarn' style={{ "borderRadius": "12px", marginLeft: "10px" }}>1688 </span> : null
                                                            }
                                                            {
                                                               relation.SupplierProduct!=null &&  relation.SupplierProduct.IsJxhyOffer == true ?
                                                                    <span className='tagStatus tagDanger' style={{ "borderRadius": "12px", marginLeft: "10px" }}>1688精选</span> : null
                                                            } */}
                                                            {relation.SupplierProduct && relation.SupplierProduct.PickupAssr ? <span className='productShow-content-sku-tag' style={{alignItems: 'center'}}>{relation.SupplierProduct.PickupAssr}h晚揽必赔</span>:null}
                                                        </li>
                                                        <li className='gysWrap flex'>
                                                            供应商旺旺: <span className='mainColor'>{relation.SupplierProduct && relation.SupplierProduct.SupplierLoginId}</span>
                                                            {
                                                                (!relation.SourcePlatform || relation.SourcePlatform == 'AlibabaZhuKe') ?
                                                                <a className="iconfont icon-wangwang" onClick={() => { window.open("https://amos.alicdn.com/getcid.aw?charset=utf-8&uid=" + relation.SupplierProduct.SupplierLoginId+ "&site=cnalichn") }}></a>:null
                                                            }
                                                        </li>
                                                        <li>
                                                            {/* <span>库存：{relation.SupplierProduct && relation.SupplierProduct.SupplyStock}</span> */}
                                                            <span>价格：￥{(relation.SupplierProduct && relation.SupplierProduct.ReferencePrice) || ''}</span>

                                                            {
                                                            relation.SourcePlatform == "TaoteZhuKe" ?
                                                                <span className='dangerColor' style={{marginLeft:'10px'}}>! 已不支持淘特货源分销，请更换1688货源</span> : null
                                                        }
                                                        </li>
                                                    </ul>
                                                </div>
                                                {/* {
                                                    (this.state.consignStatus == 0 || this.state.consignStatus == 1) && item.Relations.length > 1 ?
                                                        <div className='relationWrap-right'>
                                                            <div className="defColor hover" onClick={() => this.changeProductConfirm02(item, 0,relation)}>更换货源</div>
                                                            <div className="hover" onClick={() => this.delRelation(relation)}>删除</div>
                                                        </div> : null
                                                } */}
                                            </div>
                                        )
                                    }

                                </div>
                            </td>
                            
                            <td className='proxyOperate' style={{padding:'0 0'}}>
                               
                                {
                                    (this.state.consignStatus == 0 || this.state.consignStatus == 1) && item.Relations.length == 1 ?
                                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                                            <div style={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap', gap: '10px' }}>
                                            <MyPopover
                                                trigger="click" content={
                                                    <div className='myPopover-contetnt'>
                                                        <div className='myPopover-contetnt-item' onClick={() => this.changeProductConfirmByAlibaba(item, item.Relations[0])}>1688低价找货源</div>
                                                        <div className='myPopover-contetnt-item' style={{borderTop: '1px solid #eee'}} onClick={() => this.changeProductConfirm02(item, 0, item.Relations[0])}>店管家找同款</div>
                                                    </div>
                                                }
                                            >
                                                {
                                                <div>
                                                    <span className="defColor hover">更换货源 <i className="iconfont icon-down" style={{ "fontSize": "10px", marginLeft: "4px" }}></i></span>
                                                </div>
                                                }
                                            </MyPopover>
                                                <span className="defColor hover" onClick={() => this.showSkuMapping(item.Product)}>匹配规格</span>
                                                
                                                {
                                                    item.Relations.findIndex(x => x.SourcePlatform == 'TaoteZhuKe') == -1 ?
                                                    <span className="defColor hover" onClick={() => this.addSupplierProduct(item,0)}>添加货源</span>:<span></span>
                                                }
                                                
                                                <span className="defColor hover" onClick={() => { toProductEditPage(item.Product) }}>编辑商品</span>
                                            </div>
                                        </div> : null
                                }
                                {
                                    (this.state.consignStatus == 0 || this.state.consignStatus == 1) && item.Relations.length > 1 ?
                                        <div  style={{display:'flex',justifyContent:'space-between',width: '100%',height: '100%',}}>
                                            <div className='proxyOperate-l' >
                                                {
                                                    item.Relations.map(relation =>
                                                        <div className='proxyOperate-l-box' key={relation.RelationCode}>
                                                              <MyPopover
                                                                trigger="click" content={
                                                                    <div className='myPopover-contetnt'>
                                                                       <div className='myPopover-contetnt-item' onClick={() => this.changeProductConfirmByAlibaba(item, relation)}>1688低价找货源</div>
                                                                        <div className='myPopover-contetnt-item' onClick={() => this.changeProductConfirm02(item, 0, relation)}>店管家找同款</div>
                                                                    </div>
                                                                }
                                                            >
                                                                {
                                                                    <div>
                                                                        <span className="defColor hover">更换货源 <i className="iconfont icon-down" style={{ "fontSize": "10px", marginLeft: "4px" }}></i></span>
                                                                    </div>
                                                                }
                                                            </MyPopover>

                                                            <div className="hover" style={{flex: 2}} onClick={() => this.delRelation(relation)}>删除</div>
                                                        </div>)
                                                }
                                            </div>
                                            <div  className='proxyOperate-r'>
                                                <span style={{flex:'15% 0'}} className="defColor hover" onClick={() => this.showSkuMapping(item.Product)}>匹配规格</span>
                                                <span style={{flex:'15% 0'}} className="defColor hover" onClick={() => this.addSupplierProduct(item,0)}>添加多货源</span>
                                                <span style={{flex:'15% 0'}} className="defColor hover" onClick={() => { toProductEditPage(item.Product) }}>编辑商品</span>
                                            </div>
                                        </div> : null
                                }
                                {
                                    this.state.consignStatus != 0 && this.state.consignStatus != 1 ?
                                        <div>
                                            <span className="defColor hover" onClick={() => { toProductEditPage(item.Product) }}>编辑商品</span>
                                        </div> : null
                                }
                            </td>
                        </tr>
                    )}

                </tbody>
            </table>
        return ele;
    }


    render() {

        return (
            <div className='wrap proxyProduct'>
                <HeaderMenu />
                <main>
                    <div className='wrap-left scroll-x' >
                        <NavMenu changeNav={this.changeLeftNav} defaultActive={"/proxyProduct"} />
                    </div>
                    <div className="wrap-right">
                        <ShowWarn isShow={this.state.isShowWarn} targetUrl={this.changeNav}
                            from_action={systemConfig.zhukeAlibabaAuth === false ? 'alibaba_auth_expire' : systemConfig.zhukeTaoteAuth === false ? 'taote_auth_expire' : null}
                            alibabaNickName={getZkShopName()} taoteNickName={getTaoteShopName()} />

                        <div className='searchWrap mywrap'>
                            <div className="zk-search">
                                <div className="zk-search-wrap">
                                    {/* <label>
                    <select id="productListSelectShopId">
                      <option value="">请选择店铺</option>
                      {
                        this.state.shopList.map((item) =>
                          <option value={item.Id} platformType={item.PlatformType} selected>{item.ShopName}</option>
                        )
                      }
                    </select>
                  </label> */}
                                    {/* <label>
                                        <input type="text" id="productTitleId" placeholder="请输入商品关键字" />
                                    </label> */}
                                    <label style={{ marginLeft: "10px" }}>

                                        {
                                            <Select clearable={true} style={{marginRight: "10px" }} value={this.state.searchPlatform} onChange={(val) => { this.setState({ searchPlatform: val }) }}>
                                                <Select.Option key="All" label="货源平台" value="0" />
                                                <Select.Option key="1688" label="1688" value="1" />
                                                <Select.Option key="Taote" label="淘特" value="2" />
                                            </Select>
                                        }


                                        <Select onChange={this.changeSelect.bind(this, "searchType")} value={this.state.searchType} clearable={true} style={{marginRight: "10px" }}	>
                                            <Select.Option key="ProductID" label="商品ID" value="ProductID" />
                                            <Select.Option key="ProductSubject" label="商品标题" value="ProductSubject" />
                                        </Select>
                                        <input style={{ marginTop: 0 }} type="text" id="productTitle" placeholder="输入值" />
                                    </label>
                                    <label>
                                        <input type="text" id="supplierLoginId" placeholder="供应商" />
                                    </label>
                                </div>
                                <Button type="primary" onClick={() => this.queryButton(true)}>查询</Button>
                            </div>
                        </div>
                        <div className='mywrap'>

                            <TableNavChange distributionStatus={this.state.distributionStatus} changeNav={this.changeNav} />




                            {/* 新写方法展示 */}
                            {
                                false ?
                                    <table class="table-style01 orderList">
                                        <thead>
                                            <tr>
                                                <th style={{ width: "80px" }}>
                                                    <input type="checkbox" id="allCheck_id_Above" onClick={() => this.allCheckbox("above")} />
                                                </th>
                                                <th style={{ width: "25%", minWidth: "300px;" }}>货源商品及平台</th>
                                                <th style={{ minWidth: "120px" }}>价格</th>
                                                <th style={{ minWidth: "150px" }}>铺货平台/店铺</th>
                                                <th style={{ minWidth: "150px" }}>店铺商品信息</th>
                                                <th style={{ minWidth: "100px" }}>价格</th>
                                                <th style={{ minWidth: "180px" }}>操作</th>
                                            </tr>
                                        </thead>
                                        <tbody>

                                            {
                                                this.state.isNoShopList ?
                                                    <tr>
                                                        <td className="noneData" colSpan="20">
                                                            <div className="noneData-wrap">
                                                                <i className="iconfont icon-wushuju"></i>
                                                                <span className="noneData-title">暂无数据！</span>
                                                            </div>
                                                        </td>
                                                    </tr> : null
                                            }

                                            {this.state.consignProductList.map((item) =>
                                                <tr>
                                                    <td>
                                                        {
                                                            item.checked ?
                                                                <input type="checkbox" checked onClick={() => this.productCheckbox(item)} /> :
                                                                <input type="checkbox" onClick={() => this.productCheckbox(item)} />
                                                        }

                                                    </td>
                                                    <td>
                                                        <div class="productShow table-product">
                                                            <div class="productShow-imgWrap">
                                                                <img src={item.SupplierProduct.PicURI}
                                                                    alt="" />
                                                                {/* {item.SupplierProduct.Status == 'published' ? <span class="product-status">上架中</span> : null} */}
                                                                {item.SupplierProduct.Status == 'member expired' ? <span class="product-status">会员删除</span> : null}
                                                                {item.SupplierProduct.Status == 'expired' ? <span class="product-status">过期</span> : null}
                                                            </div>
                                                            <ul>
                                                                <li title={item.SupplierProduct.Subject}>
                                                                    <span className='defColor hover' onClick={() => huoyuanLinkReport(item.SupplierProduct,this.state.alibabaPageKey)}>{item.SupplierProduct.Subject}</span>

                                                                    {/* {
                                                                        item.Relation.SourcePlatform == "TaoteZhuKe" ?
                                                                            <span className='tagStatus tagWarn' style={{ "borderRadius": "12px", marginLeft: "10px" }}>淘特货源 </span> : null
                                                                    }
                                                                    {
                                                                        (!item.Relation.SourcePlatform || item.Relation.SourcePlatform == 'AlibabaZhuKe') ?
                                                                            <span className='tagStatus tagWarn' style={{ "borderRadius": "12px", marginLeft: "10px" }}>1688 </span> : null
                                                                    }
                                                                    {
                                                                        item.Relation.SupplierProductTag == "pifatuan" ?
                                                                            <span className='tagStatus tagDanger' style={{ "borderRadius": "12px", marginLeft: "10px" }}>1688精选</span> : null
                                                                    } */}
                                                                    {item.SupplierProduct && item.SupplierProduct.PickupAssr ? <span className='productShow-content-sku-tag' style={{alignItems: 'center'}}>{item.SupplierProduct.PickupAssr}h晚揽必赔</span>:null}
                                                                </li>
                                                                {
                                                                    item.Relation.SourcePlatform != "TaoteZhuKe" ?
                                                                        <li className="gysWrap flex"><span class="mainColor">{item.Relation.SupplierLoginId}</span><a className="iconfont icon-wangwang"></a></li> : null
                                                                }
                                                            </ul>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div class="mainColor">¥ {item.SupplierProduct.ReferencePrice}
                                                            {/* <i style={{ padding: "0 5px" }}>/</i>{item.SupplierProduct.SupplyStock} */}
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div style={{ display: "flex", alignItems: "center" }}>
                                                            <PlatformName platformType={item.Product.PlatformType} isHidePatformName={true} />
                                                            {/* <span style={{ padding: "0 3px" }}>/</span> */}
                                                            <span class="mainColor">{item.ShopName}</span>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <span>商品名称：{item.Product.Subject}</span>
                                                        <div style={{ display: "flex", flexDirection: "column" }}>
                                                            <span >商品Id：{item.Product.PlatformId}</span>
                                                            {/* {item.Product.Status == 'published' ? <span style={{ width: "30px", textAlign: "center" }} className='defBackColor fffColor'>在售</span> : <span style={{ width: "30px", textAlign: "center" }} className='warnBackColor fffColor'>下架</span>} */}
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <span className='mainColor'>￥{item.Product.minPrice}</span>
                                                        {
                                                            item.Relation.ExtField1 != null && item.Relation.ExtField1 != "0" && item.Relation.ExtField1 != "" ?
                                                                <span style={{ color: "#999", display: "block", marginTop: "5px" }}>两件{item.Relation.ExtField1}折</span> : null
                                                        }

                                                    </td>
                                                    <td className='proxyOperate'>
                                                        {/* <span className="defColor hover" style={{ padding: "0 8px" }} onClick={() => this.changeProductConfirm(item.Relation.RelationCode, item.Product.PlatformType)}>更换货源</span> */}
                                                        <MyPopover
                                                                trigger="click" content={
                                                                    <div className='myPopover-contetnt'>
                                                                        <div className='myPopover-contetnt-item' onClick={() => this.changeProductConfirm02(item,1)}>1688低价找货源</div>
                                                                        <div className='myPopover-contetnt-item' onClick={() => this.changeProductConfirm02(item, 0,0)}>店管家找同款</div>
                                                                    </div>
                                                                }
                                                            >
                                                                {
                                                                    <div>
                                                                        <span className="defColor hover">更换货源 <i className="iconfont icon-down" style={{ "fontSize": "10px", marginLeft: "4px" }}></i></span>
                                                                    </div>
                                                                }
                                                            </MyPopover>
                                                            {
                                                                <span className="defColor hover" onClick={() => this.changeProductConfirm02(item, 1)}>搜同款</span>
                                                            }

                                                            {
                                                                this.state.consignStatus == 0 || this.state.consignStatus == 1 ?
                                                                    <span className="defColor hover" onClick={() => this.relevanceProducShowButt(item.Relation.RelationCode, item.Product.PlatformType)}>规格映射</span>
                                                                    : null
                                                            }

                                                            {/* <span style={{ padding: "0 8px" }} className="defColor hover" onClick={() => this.huoyuanLink(item.SupplierProduct)}>货源</span> */}
                                                            <span className="defColor hover" onClick={() => { toProductEditPage(item.Product) }}>编辑商品</span>
                                                    </td>
                                                </tr>
                                            )}

                                        </tbody>
                                    </table> : null
                            }
                            {
                                this.tableRender()
                            }
                            <div className='paginationwrap' style={{ "marginBottom": "30px" }}>
                                <Pagination onCurrentChange={this.changeCurrent.bind(this)} onSizeChange={this.changePageSize.bind(this)} layout="total,sizes,prev, pager, next" total={this.state.total} pageSize={this.state.pageSize} currentPage={this.state.current} pageSizes={[10, 30, 50]} />
                            </div>



                        </div>
                        <div className="zk-footer">
                            <span className="zk-footer-checkWrap">
                                <input type="checkbox" id="allCheck_id_Below" onClick={() => this.allCheckbox('below')} />
                                <span>已选取<i>{this.state.distributorProducts.filter(x => x.checked).length}</i>个货品</span>
                            </span>
                            <Button className="norDefBtn" type='primary' onClick={() => this.synchronization()}>同步库存</Button>
                            <Button className="warnBtn" type='warning' onClick={(event) => this.cancelProxy(event, "")}>终止代销</Button>

                            {/* <span className="warnBtn" style={{ backgroundColor: "#ff511c" }} onClick={() => this.delItems()}>删除</span> */}
                        </div>
                    </div>
                </main>


                {/* 规格映射 弹框 */}
                <ShowModal skin={"RelevanceProduct"} width={"730px"} showModal={this.state.isShowRelevanceProduct} sureDailog={() => this.sureRelevanceRequest(false)} titleName={'规格映射'} sureBtnName={"确定"} cancelDailog={this.closeRelevanceProduct} >
                    <div className="dailogSkuMapWrap">
                        <div className="dailogSkuMapWrap-up">

                            <div className="dailogSkuMapWrap-up-title">
                                <text>已关联{getPlatformName(this.state.selectPlatformTypeRelevance)}的商品</text>
                                <input type="checkbox" style={{ "margin-left": "10px", "margin-bottom": "2px" }} checked={this.state.isShowDeletedSku == true ? 'checked' : null} onClick={() => {
                                    this.onChangeForm(!this.state.isShowDeletedSku, 'isShowDeletedSku')
                                }} id='isShowDeletedSku' />
                                <span> 展示已删除的规格</span>
                            </div>
                            <div className="dailogSkuMapWrap-up-main">
                                <div class="productShow table-product">
                                    <div class="productShow-imgWrap">
                                        {
                                            this.state.selectProduct != null ?
                                                <img src={this.state.selectProduct.ImageUrl == null || this.state.selectProduct.ImageUrl == "" ? "" : this.state.selectProduct.ImageUrl} alt="" />
                                                : null
                                        }

                                    </div>
                                    <ul>
                                        <li title="商品标题">{this.state.selectProduct == null ? "" : this.state.selectProduct.Subject}</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="dailogSkuMapWrap-down">
                            <table className="table-style01">
                                <thead>
                                    <tr>
                                        <th style={{ width: "25%" }}>{getPlatformName(this.state.selectPlatformTypeRelevance)}规格信息</th>
                                        <th style={{ width: "60%" }}>产品信息</th>
                                        <th style={{ width: "15%" }}>操作</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        this.state.selectProduct == null || this.state.selectProduct.Skus.length == 0 ?
                                            <tr><td colSpan="2">没有规格信息</td></tr> :
                                            this.state.selectProduct.Skus.filter(s => this.state.isShowDeletedSku || s.SystemStatus != -1).map((item) =>
                                                <tr>
                                                    <td>{item.AttributeValue1}{item.AttributeValue2}
                                                        {
                                                            item.SystemStatus == -1 ?
                                                                <span class="errorColor">（已删除）</span> : null
                                                        }
                                                    </td>
                                                    {
                                                        item.SupplierSkuList != null && item.SupplierSkuList.length > 0 ?
                                                            <td>
                                                                {
                                                                    item.SupplierSkuList.map((supItem, index) =>
                                                                        <div className='SupplierSkuList-item'>
                                                                            <select className={supItem.SupplierSkuId == '' ? 'SupplierSkuList-item-select' : 'SupplierSkuList-item-select active'} onChange={(e) => this.selectSupplierProduct(e, item.SkuId, index)}>
                                                                                <option value="">请选择</option>:
                                                                                {
                                                                                    this.state.supplierProductSkuList.map((item02, index02) =>
                                                                                        supItem.SupplierSkuId == item02.value ?
                                                                                            <option value={item02.value} index={index02} selected>{item02.label}</option> :
                                                                                            <option value={item02.value} index={index02}>{item02.label}</option>
                                                                                    )
                                                                                }
                                                                            </select>
                                                                            <input type='number' className='SupplierSkuList-item-input' value={supItem.MappingCount} onChange={(e) => this.selectSupplierProduct(e, item.SkuId, index)}></input>
                                                                            {
                                                                                item.SupplierSkuList.length > 1 ?
                                                                                    <span className='dangerColor' onClick={(e) => this.deleteSupplierProductSku(e, item.SkuId, index)}>删除</span> :
                                                                                    null
                                                                            }
                                                                        </div>
                                                                    )
                                                                }
                                                            </td> :
                                                            <td>
                                                                <div className='SupplierSkuList-item'>
                                                                    <select className='SupplierSkuList-item-select' onChange={(e) => this.selectSupplierProduct(e, item.SkuId, 0)}>
                                                                        <option value="">请选择</option>:
                                                                        {
                                                                            this.state.supplierProductSkuList.map((item02, index) =>
                                                                                item.SupplierSkuId == item02.value ?
                                                                                    <option value={item02.value} index={index} selected>{item02.label}</option> :
                                                                                    <option value={item02.value} index={index}>{item02.label}</option>
                                                                            )
                                                                        }
                                                                    </select>
                                                                    <input type='number' className='SupplierSkuList-item-input' onChange={(e) => this.selectSupplierProduct(e, item.SkuId, 0)}></input>
                                                                </div>
                                                            </td>
                                                    }
                                                    <td><span className='defColor hover' onClick={(e) => this.addSupplierProductSku(e, item.SkuId)}>添加规格</span></td>
                                                </tr>
                                            )
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                </ShowModal>

                {/* 更换货源确认框 */}
                <ShowModal titleName={"更换货源"} showModal={this.state.confrimChangeProduct} hideBtn={true}>
                    <div className="showModalWrap-box-commonContent" style={{ padding: "20px", fontSize: "16px" }}>
                        <div className="showModalWrap-commonContent-item">
                            <i className="iconfont icon-wenhao icofontStatus"></i>
                            <span>当前商品已经关联过货源,确认是否更换货源?</span>
                            <span style={{ paddingLeft: "44px" }}>店铺商品被下单将全部采购新货源</span>
                        </div>
                    </div>
                    <div className="showModalWrap-box-commonfooter">
                        {
                            this.state.changeProductType==0?
                            <span onClick={() => this.loadProductSource02()} className="showModalWrap-box-footer-btn">确认更换</span>:
                            <span onClick={() => this.loadProductByAlibaba()} className="showModalWrap-box-footer-btn">确认更换</span>

                        }
                        {/* <span onClick={() => this.loadProductSource()} className="showModalWrap-box-footer-btn">确认更换</span> */}
                        
                        <span onClick={() => this.closeConfrimChangeProduct()} className="showModalWrap-box-footer-btn cancleBtn">关闭</span>
                    </div>
                </ShowModal>


                {/* 更换货源 */}
                <ShowModal  skin={"changeProductsWrap"} width={this.state.changeWidth} titleName={"更换货源"} showModal={this.state.isShowChangeProduct} hideBtn={true}>
                    <div className="showModalWrap-box-commonContent changeProductsWrap-commonContent" >
                        <div className="showModalWrap-commonContent-item">
                            <div className='showModalWrap-commonContent-warn changeProductsWrap-warn'>
                                <div className="confirmComom-icon">!</div>
                                <ul>
                                    <li>1、更换货源时，注意货源的起批量，避免因起批量不足导致不能正常采购。</li>
                                    <li>2、更换货源成功后，当店铺商品被买家下单时会全部采购新货源，并同步发货和物流信息；</li>
                                    <li>3、如想取消关联货源，可以到代销商品-代销中，找到商品并终止代销；</li>
                                    <li>4、对于未进行映射货源的店铺商品规格，则不能正常采购。</li>
                                    <li>5、您和供应商任意一方修改规格名/删除规格，都会导致匹配关系失效，需要重新进行匹配。</li>
                                </ul>
                            </div>
                        </div>
                        <div className={this.state.changeStatus == 'second' ? 'showModalWrap-commonContent-item showModalWrapstepWrap showModalWrapstepWrapsecond' : "showModalWrap-commonContent-item showModalWrapstepWrap"}>


                            <Steps space={200} active={this.state.changeStatus == 'first' ? 1 : this.state.changeStatus == 'second' ? 2 : ""}>
                                <Steps.Step description="添加货源链接"></Steps.Step>
                                <Steps.Step description="映射货源规格"></Steps.Step>
                            </Steps>

                            {/* <div className="commonContent-steps">
                                <div className={this.state.changeStatus == 'first' || this.state.changeStatus == 'second' ? 'commonContent-steps-one active' : 'commonContent-steps-one'}>
                                    <span className='commonContent-steps-one-num'>1</span>
                                    <span className='commonContent-steps-one-title'>添加货源链接</span>
                                </div>
                                <div className={this.state.changeStatus == 'second' ? 'commonContent-steps-one active' : 'commonContent-steps-one'}>
                                    <span className='commonContent-steps-one-num'>2</span>
                                    <span className='commonContent-steps-one-title'>映射货源规格</span>
                                </div>
                            </div> */}
                        </div>
                        <div style={this.state.changeStatus == 'first' ? { display: 'inline' } : { display: 'none' }}>
                            <div className="showModalWrap-commonContent-item">
                                <textarea className='link-textarea' placeholder='请输入新的1688货源商品链接或淘口令' id="textareaByChangeProductId" style={{ overflow: "hidden", width: "100%", }} onInput={() => this.inputTextareaByChangeProduct()} onBlur={(e) => this.loadSupplierProduct(e.target.value)}></textarea>
                            </div>
                            <div className="showModalWrap-commonContent-item showModalWrap-commonContent-loadWrap" style={this.state.isShowWarnText ? { display: 'flex' } : { display: 'none' }}>
                                <div style={this.state.isShowLoadAction ? { display: 'inline' } : { display: 'none' }}><span className='loadmore'></span></div>
                                {
                                    this.state.isShowWarnText ?
                                        <div className='noticeText'><i className='iconfont icon-shanchu dangerColor'></i>{this.state.noticeText}</div> :
                                        <span className='noticeText02'>{this.state.noticeText}</span>
                                }

                            </div>

                            <div className="showModalWrap-commonContent-item productShow showModalWrapProductShow" style={this.state.changeProduct != null ? { display: 'flex' } : { display: 'none' }}>
                                <span className='productShow-title'>货源信息</span>
                                <div className='productShow-content'>
                                    <div className='productShow-content-img'>
                                        <img src={this.state.changeProduct != null ? this.state.changeProduct.ImageUrl : ''}></img>
                                    </div>
                                    <ul className='productShow-content-sku'>
                                        <li>{this.state.changeProduct != null ? this.state.changeProduct.Subject : ''}</li>
                                        <li className='dangerColor'>¥{this.state.changeProduct != null ? this.state.changeProduct.PriceArr[0] : ''}
                                            ~{this.state.changeProduct != null ? this.state.changeProduct.PriceArr[this.state.changeProduct.PriceArr.length - 1] : ''}</li>
                                        <li>库存：{this.state.changeProduct != null ? this.state.changeProduct.SupplyStock : ''}</li>
                                    </ul>
                                </div>
                            </div>
                        </div>


                        <div style={this.state.changeStatus == 'second' ? { display: 'inline' } : { display: 'none' }}>
                            <div className='second-SkuMapWrap-top'>
                                <div className="dailogSkuMapWrap-up">
                                    {
                                        this.state.noticeText == '' ?
                                            <div>
                                                <div className="dailogSkuMapWrap-up-title">
                                                    <span>已关联{getPlatformName(this.state.selectPlatformTypeRelevance)}的商品</span>
                                                </div>
                                                <div className="dailogSkuMapWrap-up-main">
                                                    <div class="productShow table-product">
                                                        <div class="productShow-imgWrap">
                                                            {
                                                                this.state.selectProduct != null ?
                                                                    <img src={this.state.selectProduct.ImageUrl == null || this.state.selectProduct.ImageUrl == "" ? "" : this.state.selectProduct.ImageUrl} alt="" />
                                                                    : null
                                                            }

                                                        </div>
                                                        <ul>
                                                            <li title="商品标题">{this.state.selectProduct == null ? "" : this.state.selectProduct.Subject}</li>
                                                            <li className='dangerColor'>售价：￥{this.state.selectProduct == null || this.state.selectProduct.PriceArr == null ? "" : this.state.selectProduct.PriceArr[0]}起</li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div> :
                                            <div>
                                                <div className='productShowLoadmore'><span style={{ width: "30px", height: "30px" }} className='loadmore'></span>{this.state.noticeText}</div>
                                            </div>
                                    }
                                </div>
                                <div className='dailogSkuMapWrap-mid'>
                                    <span>对应货源</span>
                                    <i className='iconfont icon-fanhuidingbu'></i>
                                </div>
                                <div className="dailogSkuMapWrap-up">
                                    <div className="dailogSkuMapWrap-up-title">
                                        <span>已关联1688的商品</span>
                                    </div>
                                    <div className="dailogSkuMapWrap-up-main">
                                        <div class="productShow table-product">
                                            <div class="productShow-imgWrap">
                                                {
                                                    this.state.changeProduct != null ?
                                                        <img src={this.state.changeProduct.ImageUrl == null || this.state.changeProduct.ImageUrl == "" ? "" : this.state.changeProduct.ImageUrl} alt="" />
                                                        : null
                                                }
                                            </div>
                                            <ul>
                                                <li title="商品标题">{this.state.changeProduct == null ? "" : this.state.changeProduct.Subject}</li>
                                                <li className='dangerColor'>进货价：￥{this.state.changeProduct == null || this.state.changeProduct.PriceArr == null ? "" : this.state.changeProduct.PriceArr[0]}起</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="dailogSkuMapWrap-down">
                                <table className="table-style01">
                                    <thead>
                                        <tr>
                                            <th style={{ width: "350px" }}>{getPlatformName(this.state.selectPlatformTypeRelevance)}规格信息</th>
                                            <th style={{ width: "410px" }}>产品信息</th>
                                            <th style={{ width: "90px" }}>操作</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            this.state.selectProduct == null || this.state.selectProduct.Skus.length == 0 ?
                                                <tr><td colSpan="2">没有规格信息</td></tr> :
                                                this.state.selectProduct.Skus.filter(s => s.SystemStatus != -1).map((item) =>
                                                    <tr>
                                                        <td>{item.AttributeValue1}{item.AttributeValue2}</td>
                                                        {
                                                            item.SupplierSkuList != null && item.SupplierSkuList.length > 0 ?
                                                                <td>
                                                                    {
                                                                        item.SupplierSkuList.map((supItem, index) =>
                                                                            <div className='SupplierSkuList-item'>
                                                                                <select className='SupplierSkuList-item-select' onChange={(e) => this.selectSupplierProduct(e, item.SkuId, index)}>
                                                                                    <option value="">请选择</option>:
                                                                                    {
                                                                                        this.state.supplierProductSkuList.map((item02, index02) =>
                                                                                            supItem.SupplierSkuId == item02.value ?
                                                                                                <option value={item02.value} index={index02} selected>{item02.label}</option> :
                                                                                                <option value={item02.value} index={index02}>{item02.label}</option>
                                                                                        )
                                                                                    }
                                                                                </select>
                                                                                <input type='number' value={supItem.MappingCount} onChange={(e) => this.selectSupplierProduct(e, item.SkuId, index)}></input>
                                                                                {
                                                                                    item.SupplierSkuList.length > 1 ?
                                                                                        <span className='dangerColor' onClick={(e) => this.deleteSupplierProductSku(e, item.SkuId, index)}>删除</span> :
                                                                                        null
                                                                                }
                                                                            </div>
                                                                        )
                                                                    }
                                                                </td> :
                                                                <td>
                                                                    <div className='SupplierSkuList-item'>
                                                                        <select className='SupplierSkuList-item-select' onChange={(e) => this.selectSupplierProduct(e, item.SkuId, 0)}>
                                                                            <option value="">请选择</option>:
                                                                            {
                                                                                this.state.supplierProductSkuList.map((item02, index) =>
                                                                                    item.SupplierSkuId == item02.value ?
                                                                                        <option value={item02.value} index={index} selected>{item02.label}</option> :
                                                                                        <option value={item02.value} index={index}>{item02.label}</option>
                                                                                )
                                                                            }
                                                                        </select>
                                                                        <input type='number' onChange={(e) => this.selectSupplierProduct(e, item.SkuId, 0)}></input>
                                                                    </div>
                                                                </td>
                                                        }
                                                        <td><span className='defColor hover' onClick={(e) => this.addSupplierProductSku(e, item.SkuId)}>添加规格</span></td>
                                                    </tr>
                                                )
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div className="showModalWrap-box-commonfooter dailogSkuMapWrap-footer">
                        <div style={this.state.changeStatus == 'first' ? { display: 'flex' } : { display: 'none' }}>
                            <span style={this.state.changeProduct != null ? { cursor: "pointer", 'background-color': "#5584ff", border: '1px solid #5584ff' } :
                                { cursor: "not-allowed", 'background-color': "#ccc", border: '1px solid #ccc' }}
                                onClick={() => this.relevanceProducFromChange()} className="showModalWrap-box-footer-btn">下一步</span>
                        </div>
                        <span style={this.state.changeStatus == 'second' ? { display: 'flex', marginRight: "5px" } : { display: 'none' }} onClick={() => this.previousChangeProduct()}
                            className="showModalWrap-box-footer-btn cancleBtn">上一步</span>
                        <span style={this.state.changeStatus == 'second' ? { display: 'flex' } : { display: 'none' }} onClick={() => this.sureRelevanceRequest()}
                            className="showModalWrap-box-footer-btn">确定关联</span>
                        <span onClick={() => this.closeChangeProduct()} className="showModalWrap-box-footer-btn cancleBtn">关闭</span>
                    </div>
                </ShowModal>
                {/* 同步库存 */}
                <ShowModal showModal={this.state.isShowSyncInfo} hideBtn={true}>
                    <div className="showModalWrap-box-commonContent" style={{ padding: "20px", fontSize: "16px" }}>
                        <div className="showModalWrap-commonContent-item">
                            <i className="iconfont icon-wenhao icofontStatus"></i>
                            <span>同步1688货源信息</span>
                        </div>
                        <div style={{ paddingLeft: "43px" }}>重新获取1688产品的标题、价格、库存、主图等信息</div>
                        <div style={{ paddingLeft: "43px", marginTop: "10px" }} className="dangerColor">当发现货源库存有变化时，是否将新库存更新到铺货小店？</div>
                    </div>
                    <div className="showModalWrap-box-commonfooter">
                        <span onClick={() => this.synchronizationSyncPlatform(true)} className="showModalWrap-box-footer-btn">同步后更新到平台</span>
                        <span onClick={() => this.synchronizationSyncPlatform(false)} className="showModalWrap-box-footer-btn cancleBtn">暂不更新到平台</span>
                        <span onClick={() => this.synchronizationCloseButt()} className="showModalWrap-box-footer-btn cancleBtn">关闭</span>
                    </div>
                </ShowModal>

                {/* 终止代销 */}
                <ShowModal showModal={this.state.isShowCancelProxy} hideBtn={true}>
                    <div className="showModalWrap-box-commonContent" style={{ padding: "20px", fontSize: "16px" }}>
                        <div className="showModalWrap-commonContent-item">
                            <i className="iconfont icon-wenhao icofontStatus"></i>
                            <span>您正在终止该货源的代销合作，终止后，该货源的订单</span>
                            <span style={{ paddingLeft: "44px" }}>将不会自动产生对应的1688采购单</span>
                        </div>
                        <div style={{ padding: "10px 44px", color: "#f7941f" }}>
                            <label>
                                <input type="checkbox" id="cancelProxyCheckboxId" />  同时下架已铺货到店铺的商品
                            </label>
                        </div>

                    </div>
                    <div className="showModalWrap-box-commonfooter">
                        <span onClick={() => this.cancelProxyConfirmButt()} className="showModalWrap-box-footer-btn">终止代销</span>
                        <span onClick={() => this.cancelProxyCloseButt()} className="showModalWrap-box-footer-btn cancleBtn">关闭</span>
                    </div>
                </ShowModal>

                <ShowModal showModal={this.state.isShowItemCancelProxy} hideBtn={true} title={'删除货源'}>
                    <div className="showModalWrap-box-commonContent" style={{ padding: "20px", fontSize: "16px" }}>
                        <div className="showModalWrap-commonContent-item">
                            <i className="iconfont icon-wenhao icofontStatus"></i>
                            {
                                this.state.isShowItemCancelProxyRelation 
                                && this.state.isShowItemCancelProxyRelation.mappings
                                && this.state.isShowItemCancelProxyRelation.mappings.length > 0 ?
                                <span>检测到当前货源已在规格匹配中使用，店铺商品被下单，将无法采购该货源，已经存在的采购单不会受影响</span>
                                :<span>删除后，店铺商品被下单，将无法采购该货源，已经存在的采购单不会受影响</span>
                            }
                            
                        </div>

                    </div>
                    <div className="showModalWrap-box-commonfooter">
                        <span onClick={() => this.cancelProxyConfirmButt({RelationCodes:[this.state.isShowItemCancelProxyRelation.RelationCode]})} className="showModalWrap-box-footer-btn">确定</span>
                        <span onClick={() => this.changeSelect('isShowItemCancelProxy',false)} className="showModalWrap-box-footer-btn cancleBtn">关闭</span>
                    </div>
                </ShowModal>
               
                <ChangeProductsModuleV2
                    productTag={this.state.productTag}
                    selectProductId={this.state.selectedShopProduct ? this.state.selectedShopProduct.PlatformId : ""}
                    selectedShopProductImgSrc={this.state.selectedShopProduct ? this.state.selectedShopProduct.ImageUrl : ""}
                    changeSupplierProduct={this.state.changeSupplierProduct}//需要替换的货源

                    showModal={this.state.isChangeProductsModule}
                    activeSearchNavId={this.state.changeSearchNavsType}

                    closeChangeProductsModule={this.closeChangeProductsModule}
                    sureRelevanceRequest={this.sureChangeProductsModule}
                    title={this.state.changeSupplierProduct ? "更换货源":"关联货源"}
                />
                 <ChangeProductByAlibaba
                   selectProductId={this.state.selectedShopProduct?this.state.selectedShopProduct.PlatformId:""}
                   selectedShopProductImgSrc={this.state.selectedShopProduct?this.state.selectedShopProduct.ImageUrl:""}
                   changeSupplierProduct={this.state.changeSupplierProduct}//需要替换的货源
                   showModal={this.state.isChangeProductsModuleByAlibaba}
                   title="1688低价找货源"
                   sureRelevanceRequest={this.sureChangeProductByAlibaba}
                   closeChangeProductByAlibaba={this.closeChangeProductByAlibaba}
                />



                <SkuMappingsModule
                    showModal={this.state.skuMappingsModuleDailog}
                    shopId={this.state.skuMappingSelectProduct && this.state.skuMappingSelectProduct.ShopId}
                    productId={this.state.skuMappingSelectProduct && this.state.skuMappingSelectProduct.PlatformId}
                    platformType={this.state.skuMappingSelectProduct && this.state.skuMappingSelectProduct.PlatformType}
                    skuMappingsTitle='匹配规格'
                    closeSkuMappingsModule={this.closeSkuMappingsModule}
                ></SkuMappingsModule>

                <MyLoading isLoading={this.state.isLoading} isStopOperate={true} fullCenter={true} />
                <NewUserGuide></NewUserGuide>
            </div>

        )
    }
}

export default proxyProduct;


// WEBPACK FOOTER //
// ./src/pages/proxyProduct/proxyProduct.jsx